import { useMemo } from 'react';
import { useLocation } from '@namespace/i18n';
import { useMatchPath, useSearchParams } from '@namespace/router';
import { useSportBySportSlug } from '../../store';

export const useGetFilterParams = (route, serviceId) => {
  const paths = [`${route}/:sportSlug`];

  const { sportSlug } = useMatchPath(paths);
  const { pathname } = useLocation();

  const { categories: searchCategories, tournaments: searchTournaments } =
    useSearchParams();

  const tournamentIds = useMemo(
    () => searchTournaments?.map(Number) ?? [],
    [searchTournaments]
  );
  const categoryIds = useMemo(
    () => searchCategories?.map(Number) ?? [],
    [searchCategories]
  );
  const activeSport = useSportBySportSlug(sportSlug, serviceId);

  return {
    sportSlug,
    activeSport,
    categoryIds,
    tournamentIds,
    isValidPath: pathname.includes(route)
  };
};
